import { render, staticRenderFns } from "./AreaEmbargadaSigaMtPoligono.vue?vue&type=template&id=3592570e&lang=pug"
import script from "./AreaEmbargadaSigaMtPoligono.vue?vue&type=script&lang=js"
export * from "./AreaEmbargadaSigaMtPoligono.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports